import React from 'react';
import BaseFilter from './BaseFilter';
import StatusFilterPanel from './StatusFilterPanel';
import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import UIStrings from '@/Utils/UIStrings';

function StatusFilterButton(): React.JSX.Element {
    const { filterBy } = useCandidatesOverviewContext();

    return (
        <BaseFilter label={UIStrings.ApplicantStatus} activeFilterCount={filterBy.length}>
            <StatusFilterPanel />
        </BaseFilter>
    );
}

export default StatusFilterButton;
